import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Card, Col, Divider, Form, message, Row, Statistic } from 'antd';
// import util from "@util/index";
import { queryFinanceBooksOrgList } from '@api/finance/finance';
import LocalDb from '@util/localDb';
import {
  queryBudgetAnalysis,
  queryBudgetGroupList,
  queryBudgetGroupPerList,
} from '@api/finance/budget';
import { BackBtn } from '@comm/BackBtn';
import Pmgressbar from '@comm/Pmgressbar/Index';
import Pmgressbar2 from '@comm/Pmgressbar/MonthPro';
import { queryDictExpend } from '@api/core/dict';

// const { Option } = Select;
class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupList: [],
      groupUuids: [this.props.params.uuid],
      groupName: '',
      nowAimPre: 1,
      incomeData: [],
      expenditureData: {},
    };
  }

  componentWillMount() {}

  async componentDidMount() {
    await this.getNowAimPre();
    await this.getGroupList();
    await this.getDictExpend();
    this.getAnalysis();
    this.getOrg();
  }

  /**
   * 递归删除空的children
   */
  formatGroup = arr => {
    arr.map(item => {
      if (item.children) {
        if (item.children.length === 0) {
          delete item.children;
          return item;
        }
        if (item.children.length > 0) {
          this.formatGroup(item.children);
        }
      }
      return item;
    });
    return arr;
  };

  // 设置预算组下拉菜单
  formatOption = arr => {
    const { groupList } = this.state;
    (arr || []).map(item => {
      if (item.children && item.children.length > 0) {
        this.formatOption(item.children);
      }
      groupList.push(item);
      return item;
    });
    this.setState(
      {
        groupList,
      },
      () => {
        this.setGroupName([this.props.params.uuid]);
      },
    );
  };

  // 换算当前目标收入
  getNowAimPre = () => {
    let nowAimPre = 0;
    const { year } = this.props.params;
    if (year) {
      const yStart = new Date(+year, 0, 1, 0, 0, 0, 0);
      const yEnd = new Date(+year + 1, 0, 1, 0, 0, 0, 0);
      const yNow = Date.now();

      if (yNow <= yStart) {
        nowAimPre = 0;
      } else if (yNow >= yEnd) {
        nowAimPre = 1;
      } else {
        nowAimPre = Math.floor(((yNow - yStart) / (yEnd - yStart)) * 10000) / 10000;
      }

      this.setState({
        nowAimPre,
      });
    }
  };

  // 预算组列表
  getGroupList = () => {
    const params = {
      isEnable: 1,
      year: this.props.params.year,
    };
    this.props.location.query.source
      ? queryBudgetGroupList(params).then(res => {
          if (res.statusCode === 200) {
            const companyList = this.formatGroup(res.data);
            this.formatOption(companyList);
          } else {
            message.error(res.message);
          }
        })
      : queryBudgetGroupPerList(params).then(res => {
          if (res.statusCode === 200) {
            const companyList = this.formatGroup(res.data);
            this.formatOption(companyList);
          } else {
            message.error(res.message);
          }
        });
  };

  // 页面加载时设置预算组名
  setGroupName = uuidArr => {
    let str = '';
    const { groupList } = this.state;

    uuidArr.map(item => {
      groupList.map(it => {
        if (it.uuid === item) {
          str += `${it.name},`;
        }
        return it;
      });
      return item;
    });
    str = str.substring(0, str.length - 1);
    this.setState({
      groupName: str,
    });
  };

  getDictExpend = () => {
    queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          expendType: res.data,
        });
      }
    });
  };

  // 获取收支数据
  getAnalysis = () => {
    const { nowAimPre, groupUuids } = this.state;
    const params = {};
    params.groupUuids = groupUuids.length ? groupUuids : [this.props.params.uuid];
    params.year = this.props.params.year;
    queryBudgetAnalysis(params).then(res => {
      if (res.statusCode === 200) {
        const { income, expenditure } = res.data;
        income.map((item, index) => {
          item.index = index;
          item.nowAimincomeValue = item.aim * nowAimPre;
          item.acturalPre = item.aim ? Math.floor((item.actual / item.aim) * 10000) / 10000 : 0;
          return 1;
        });

        expenditure.actualPre = expenditure.budget
          ? Math.floor((expenditure.actual / expenditure.budget) * 10000) / 10000
          : 0;
        expenditure.top.forEach(item => {
          item.typeName = this.findTypeName(item.type);
        });
        this.setState({
          incomeData: res.data.income,
          expenditureData: res.data.expenditure,
        });
      }
    });
  };

  // 获取预算组公司(以判断运营报表是否去详情页)
  getOrg = () => {
    const { groupUuids } = this.state;
    queryFinanceBooksOrgList({
      groupUuids,
    }).then(res => {
      if (res.statusCode === 200) {
        const org = res.data;
        this.setState({
          org,
        });
      }
    });
  };

  findTypeName = key => {
    let typeName = '';
    const { expendType } = this.state;
    expendType.forEach(item => {
      if (key === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  // 改变预算组
  changeGroup = e => {
    if (e) {
      e.preventDefault();
    }

    const { groupUuids } = this.props.form.getFieldsValue();
    this.props.params.uuid = groupUuids;

    if (groupUuids.length >= 1) {
      this.setGroupName(groupUuids);
      this.setState(
        {
          groupUuids,
        },
        () => {
          this.getAnalysis();
          this.getOrg();
        },
      );
    }
  };

  // 设置年份
  setLocalDbYear = () => {
    const { year } = this.props.params;
    LocalDb.set('year', year);
  };

  render() {
    const urlPrefix = `/finance/budget/${
      this.state.groupUuids.length ? this.state.groupUuids : this.props.params.uuid
    }/balance`;
    const { incomeData, expenditureData, nowAimPre, groupUuids, groupName, org } = this.state;

    // const { getFieldDecorator } = this.props.form;
    const extra = (
      <Form onSubmit={this.changeGroup}>
        <Row>
          {/* <Col span={11}>
            <Form.Item>
              {getFieldDecorator("groupUuids", {
                initialValue:
                  this.state.groupList && this.state.groupList.length
                    ? this.state.groupUuids
                    : null
              })(
                <Select
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="选择预算组"
                >
                  {this.state.groupList.map(item => {
                    return <Option value={item.uuid}>{item.name}</Option>;
                  })}
                </Select>
              )}
            </Form.Item>
          </Col>
          <Col span={3} style={{ marginLeft: "10px" }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                确定
              </Button>
            </Form.Item>
          </Col> */}
          <Col span={8} style={{ paddingTop: '10px', paddingRight: '10px' }}>
            {groupUuids.length > 1 ? (
              <Link
                to={{
                  pathname: `/finance/budgets`,
                  query: { groupUuids },
                }}
              >
                预算统计
              </Link>
            ) : (
              <Link
                onClick={this.setLocalDbYear}
                to={{
                  pathname: `/finance/budgets/${groupUuids}/year`,
                  query: { companyName: groupName },
                }}
              >
                预算统计
              </Link>
            )}
          </Col>
          <Col span={8} style={{ paddingTop: '10px', paddingRight: '10px' }}>
            {org && org.length > 1 ? (
              <Link
                to={{
                  pathname: `/finance/operational`,
                  query: {
                    groupUuids,
                  },
                }}
              >
                运营报表
              </Link>
            ) : (
              <Link
                to={{
                  pathname: `/finance/operational/${groupUuids}/year`,
                  query: {
                    companyName: groupName,
                    isBalance: true,
                  },
                }}
              >
                运营报表
              </Link>
            )}
          </Col>
          <Col span={8} style={{ paddingTop: '10px', paddingRight: '10px' }}>
            <Link
              to={{
                pathname: `${urlPrefix}/trace`,
                query: {
                  year: this.props.params.year,
                },
              }}
            >
              利润追踪
            </Link>
          </Col>
        </Row>
      </Form>
    );

    return (
      <div>
        <Row style={{ marginBottom: '10px' }}>
          <BackBtn />
        </Row>
        <Card title="收支分析" extra={extra}>
          {incomeData && incomeData.length ? (
            <Row type="flex" justify="end">
              <Col span={19} style={{ textAlign: 'right' }}>
                <Link
                  style={{ marginRight: '8px' }}
                  to={{
                    pathname: `${urlPrefix}/income`,
                    query: {
                      year: this.props.params.year,
                    },
                  }}
                >
                  收入分析
                </Link>
              </Col>
            </Row>
          ) : null}
          {incomeData && incomeData.length
            ? incomeData.map(item => {
                return (
                  <div key={item.index}>
                    <Row style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                      <Col span={5}>
                        <Statistic
                          title={`本年${item.typeName}目标收入：`}
                          value={item.aim}
                          precision={2}
                          valueStyle={{ color: '#55AA88' }}
                          suffix="元"
                        />
                        <Statistic
                          title="实际收入："
                          value={item.actual}
                          precision={2}
                          valueStyle={{ color: '#55AA88' }}
                          suffix="元"
                        />
                      </Col>
                      <Col span={18} style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                        <Pmgressbar
                          data={[
                            {
                              type: '目标',
                              per: item.aim ? nowAimPre : 0,
                              value: item.nowAimincomeValue || 0,
                              color: 'rgba(25, 144, 255)',
                              location: 'top',
                            },
                            {
                              type: '实际',
                              per: item.acturalPre,
                              value: item.actual || 0,
                              color: item.acturalPre >= nowAimPre ? 'rgba(82,196,26)' : 'red',
                            },
                          ]}
                        />
                      </Col>
                    </Row>
                    <Divider />
                  </div>
                );
              })
            : null}

          <Row>
            <Col span={5}>
              <Statistic
                title="本年总计预算支出："
                value={expenditureData.budget}
                precision={2}
                valueStyle={{ color: 'red' }}
                suffix="元"
              />
            </Col>
            <Col span={19} style={{ textAlign: 'right' }}>
              <Link
                style={{ marginRight: '8px' }}
                to={{
                  pathname: `${urlPrefix}/expense`,
                  query: {
                    year: this.props.params.year,
                  },
                }}
              >
                支出分析
              </Link>
            </Col>
          </Row>

          <Row type="flex" justify="space-between">
            <Col span={5}>
              <Statistic
                title="实际支出："
                value={expenditureData.actual}
                precision={2}
                valueStyle={{ color: 'red' }}
                suffix="元"
              />
            </Col>
            <Col span={18}>
              <Pmgressbar2
                per={parseFloat(expenditureData.actualPre)}
                money={expenditureData.actual}
                nowAimPre={expenditureData.budget ? nowAimPre : 0}
              />
            </Col>
          </Row>
          {/* {expenditureData.top && expenditureData.top.length > 0 ? (
            <Row style={{ marginTop: "16px" }} type="flex" justify="end">
              <Col span={18}>
                <List
                  grid={{ gutter: 16, column: 4 }}
                  dataSource={expenditureData.top}
                  renderItem={(item, index) => (
                    <List.Item>
                      <Card title={`No${index + 1}${item.typeName}`}>
                        <p>￥{util.numberFormat(item.price)}</p>
                      </Card>
                    </List.Item>
                  )}
                />
              </Col>
            </Row>
          ) : null} */}
        </Card>
      </div>
    );
  }
}

export default connect(state => ({
  incomeData: state.payable_statis,
  allCompany: state.all_company,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/budget/balance/index.js